import { render, staticRenderFns } from "./major_bank_buttons.vue?vue&type=template&id=c4bc9468&scoped=true&"
var script = {}
import style0 from "./major_bank_buttons.vue?vue&type=style&index=0&id=c4bc9468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bc9468",
  null
  
)

export default component.exports